package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class ContentEntityType(private val literal: String) : IEnumType {
	Book("Book"),
	User("User"),
	Organization("Organization"),
	Club("Club"),
	Meridian("Meridian");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "content_entity_Type"}
	override fun getLiteral(): String {return literal}
}
